import axios from 'axios';
import CustomError from '../utils/customError';
import { generatePdfEndpoint } from './endpoints';
// import mockPdfContract from '../mock/mockPdfContract';
import { PDF_CONTRACT_TEMPLATE, CLIENT_TYPE } from '../constants/defaults';

const getPdfContract = async (parsedUserData, setContracts, setError) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${parsedUserData.authorized.jwt.access_token}`
      }
    };

    // assigned id template
    let idTemplate = PDF_CONTRACT_TEMPLATE.master;
    switch (parsedUserData.idTypeClient) {
      case CLIENT_TYPE.master:
        idTemplate = PDF_CONTRACT_TEMPLATE.master;
        break;
      case CLIENT_TYPE.upgrade:
        idTemplate = PDF_CONTRACT_TEMPLATE.upgrade;
        break;
      case CLIENT_TYPE.visa:
        idTemplate = PDF_CONTRACT_TEMPLATE.visa;
        break;
      default:
        idTemplate = PDF_CONTRACT_TEMPLATE.master;
        break;
      }
      const data = {
        idTemplate,
        metadata: { content: parsedUserData },
      };
      
    const response = await axios.post(generatePdfEndpoint(), data, config);

    if (!response || parseInt(response.status) !== 200) {
      throw new CustomError({
        type: 'PDF DOWNLOAD',
        message: 'Error al generar el contrato.',
      });
    }
    setContracts(response.data);
    return response.data;
  } catch (error) {
    setError(error);
  }
};

export default getPdfContract;
